import {useSelector, useDispatch} from 'react-redux';
import Selector from '../../../../selectors/modules/lucky_wheel/prize';
import { claimPrize } from '../../../../reducers/lucky-wheel/actions';
import {AnimatePresence, motion} from 'framer-motion';
import Button from './button';
import ModalsLib from '../../../../lib/modals';

export default () => {
    const {prize, button} = useSelector(Selector),
          dispatch = useDispatch();

    return (
        <AnimatePresence>
            {prize && (
                <motion.div
                    className="wheel-prize"
                    key="wheel-prize"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1 }}
                    exit={{ opacity: 0 }}
                    transition={{
                        duration: 0.25,
                        ease: "easeInOut"
                    }}
                >
                    <div className={`prize-item ${prize.appearance.color}`}>
                        <motion.div
                            key="circle"
                            className="circle"
                            animate={{
                                rotate: -360,
                            }}
                            transition={{
                                duration: 3,
                                repeat: Infinity,
                                ease: 'linear',
                            }}
                        />
                        <div className="prize-object">
                            <div className={prize.appearance.key} />
                        </div>
                    </div>

                    <div className="won"></div>
                    <div className="prize-name" dangerouslySetInnerHTML={{__html: prize.appearance.name}}></div>
                    <Button button={button} onClick={e => {
                        if(!button) {
                            if(prize.type === "freeplay")
                                ModalsLib.open('changeGame', {
                                    handler: e => {
                                        ModalsLib.close();
                                        dispatch(claimPrize(prize.id, e));
                                    }
                                });
                            else
                                dispatch(claimPrize(prize.id));
                        }
                    }} />
                </motion.div>
            )}
        </AnimatePresence>
    )
}